/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { render } from 'react-dom';
import {
  BrowserRouter,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import App from './App';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';

const tagManagerArgs = {
  gtmId: process.env.GOOGLE_TAG_MANAGER_ID,
};

const production = process.env.FIREBASE_PROJECT_ID === 'new-one-41580';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  enabled: production,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  environment: production ? 'production' : 'development',
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

TagManager.initialize(tagManagerArgs);

render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);
